import http from "@/lib/http/client"
import { Credential } from "@/types/api"

export const listApiKeys = async (): Promise<Credential[]> => {
  const res = await http.get(`/credentials`)
  return res.data
}

export const generateApiKey = async (name: string, description: string): Promise<{ api_key: string }> => {
  const res = await http.post(`/credentials`, { name, description })
  return res.data
}

export const deleteApiKey = async (id: string): Promise<void> => {
  const res = await http.delete(`/credentials/${id}`)
  return res.data
}
